export const CABIN_CATEGORY_CODES = {
  INSIDER: 'INSIDER',
  MEGA_ROCKSTAR: 'MEGA ROCKSTAR',
  ROCKSTAR_SUITES: 'ROCKSTAR SUITES',
  SEA_TERRACE: 'SEA TERRACE',
  SEA_VIEW: 'SEA VIEW',
};
